import { clsx } from 'clsx';

import { type ButtonProps } from './button.types';

export const Button = ({
  text,
  onClick,
  variant,
  size = 'md',
  disabled,
  icon,
  loading,
  ...props
}: ButtonProps) => (
  <button
    {...props}
    className={clsx('btn', `btn-${variant}`, `btn-${size}`, {
      'btn-disabled': disabled,
      'animate-spin': loading,
      [`${props.className}`]: props.className,
    })}
    onClick={onClick}
  >
    {icon && icon}
    {text}
  </button>
);
